export default __webpack_public_path__ + "static/media/basketball.10f3bc85.webp";